import { useCurrentUser } from '@klp/auth';
import { Block } from '@klp/design/Block';
import { Heading } from '@klp/design/Heading';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { PortfolioSelector } from '@klp/portfolio/components';
import { Grid } from '@material-ui/core';
import React from 'react';
import AdjustFrontpageDialog from './AdjustFrontpageDialog';
import { useSelector } from 'react-redux';
import { contextSelectors } from '@klp/contextSelector/index';
import { usePortfolio } from '@klp/portfolio/store';

export const FrontpageTitle = () => {
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);
    const { portfolio } = usePortfolio();

    const showcasedUser =
        (currentUser?.isEDAdmin ? portfolio?.fornavn : currentUser?.fornavn) ||
        '';

    return (
        <Grid container={true} direction="row">
            <Block paddingRight="tiny">
                <Grid item={true}>
                    <Illustration
                        icon={IconName.HOME}
                        klpPalette="primary"
                        klpColor="main"
                        size="medium"
                    />
                </Grid>
            </Block>
            <Grid item={true}>
                {selectedContext && (
                    <Heading klpHeadingLevel="THREE" klpColor="dark">
                        {selectedContext?.eiendomsNummer}
                        {selectedContext?.navn}
                    </Heading>
                )}
                {!selectedContext && (
                    <Heading
                        klpHeadingLevel="THREE"
                        translation="frontPage.welcome.yourAdminDashboard"
                        translationOptions={{
                            name: showcasedUser,
                        }}
                        align="left"
                        data-testid="Frontpage__Title"
                    />
                )}
            </Grid>
            {currentUser?.isEDAdmin && (
                <Block paddingBottom="compact" paddingLeft="compact">
                    <Grid item={true}>
                        <PortfolioSelector />
                    </Grid>
                </Block>
            )}
            <Block paddingBottom="compact" paddingLeft="compact">
                <AdjustFrontpageDialog />
            </Block>
        </Grid>
    );
};
